import * as React from "react";
function SvgHome(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.293 1.293a1 1 0 011.414 0l10 10-1.414 1.414L20 11.414V20a2 2 0 01-2 2H6a2 2 0 01-2-2v-8.586l-1.293 1.293-1.414-1.414 10-10zM10 20h4v-4a2 2 0 10-4 0v4zm6 0h2V9.414l-6-6-6 6V20h2v-4a4 4 0 018 0v4z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgHome);
export default ForwardRef;
